import { refs, throttle, booleanDataset, dispatchEvent } from '../modules/utils.js';
import { test as testMedia } from '../modules/match-media';
import gsap from 'gsap';

class TopBar extends HTMLElement {
  static get observedAttributes() {
    return ['data-menu'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-menu') {
      const value = newValue === '';
      this.dataset.style = value ? 'light' : this.dataset.stylePrev;
      this.#tweenIcon(value);
    }
  }

  async connectedCallback() {
    await new Promise(resolve => setTimeout(resolve, 0));

    if (!this.moved) {
      this.refs = refs(this);
      this.#listeners();
      this.#scrollHandle();
      this.#homeHandle();
    }

    setTimeout(() => booleanDataset(this, 'active', true), 1);
  }

  #listeners() {
    this.refs.iconMenu.addEventListener('click', () => dispatchEvent('topbar:menu'));
    document.addEventListener('navoverlay:display', ({ detail }) => {
      if (detail.value) {
        this.dataset.stylePrev = this.dataset.style;
      }
      booleanDataset(this, 'menu', detail.value);
    });
  }

  #homeHandle() {
    if (document.body.classList.contains('page-home') && !testMedia('small')) {
      this.moved = true;
      const firstBlock = document.querySelector('.layout-block');
      firstBlock.after(this);
    }
  }

  #tweenIcon(isMenu) {
    const paths = this.refs.iconMenu.querySelectorAll('path');

    if (isMenu) {
      // Transform to X
      gsap.to(paths[0], {
        rotation: 45,
        y: 4,
        transformOrigin: "center center",
        duration: 0.3,
        ease: "power2.inOut"
      });

      gsap.to(paths[1], {
        rotation: -45,
        y: -4,
        transformOrigin: "center center",
        duration: 0.3,
        ease: "power2.inOut"
      });
    } else {
      // Transform back to hamburger
      gsap.to(paths[0], {
        rotation: 0,
        y: 0,
        transformOrigin: "center center",
        duration: 0.3,
        ease: "power2.inOut"
      });

      gsap.to(paths[1], {
        rotation: 0,
        y: 0,
        transformOrigin: "center center",
        duration: 0.3,
        ease: "power2.inOut"
      });
    }
  }

  #scrollHandle() {
    let y = window.scrollY;

    const scrollTest = function () {
      const currentY = window.scrollY;

      if (currentY <= 0) {
        booleanDataset(this, 'onTop', true);
      }
      else {
        booleanDataset(this, 'onTop', false);
      }

      if (currentY > y) {
        this.dataset.scrollDirection = 'down';
      }
      else if (currentY < y) {
        this.dataset.scrollDirection = 'up';
      }

      y = currentY;
    }.bind(this);

    // immediate call
    scrollTest();
    setTimeout(scrollTest, 1000);

    window.addEventListener('scroll', throttle(scrollTest, 50));
  }
}

customElements.define('top-bar', TopBar);
